// src/components/income/EmptyState.tsx
import React from 'react';
import { Plus, Wallet } from 'lucide-react';

interface EmptyStateProps {
  onAdd: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({ onAdd }) => (
  <div className="text-center py-12 bg-white rounded-xl shadow-lg">
    <Wallet className="w-12 h-12 text-gray-400 mx-auto mb-4" />
    <h3 className="text-lg font-medium text-gray-900 mb-2">No income found</h3>
    <p className="text-gray-500 mb-4">Get started by adding your first income source</p>
    <button onClick={onAdd} className="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center mx-auto">
      <Plus className="w-4 h-4 mr-2" />Add Income
    </button>
  </div>
);

export default EmptyState;